import React from 'react'
import { SxProps, Theme } from '@mui/material/styles'
import { AnchorProps, StyledAnchor as BaseComponent } from './StyledAnchor.style'

type StyledAnchorProps = {
  sx?: SxProps<Theme>
} & AnchorProps

export const StyledAnchor: React.FC<StyledAnchorProps> = (props) => {
  const { target='_blank', rel='noopener', ...rest } = props

  return (
    <BaseComponent
      target={target}
      rel={rel}
      {...rest} />
  )
}
